import R from 'app/assets/R'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { useModalHook } from './hook'
import { IPropsDeleteJobTitleLevel } from './type'
import { BaseCol } from 'app/components/common/BaseCol'
import * as S from './styles'

export const Delete = (props: IPropsDeleteJobTitleLevel) => {
  const { visible, isLoading, showModal, handleCancel, handleSubmit, t } =
    useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="delete"
      titleKeyI18n={R.strings.delete}
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.delete}
      confirmKeyI18n={R.strings.delete}
      handleSubmit={handleSubmit}
      visible={visible}
      widthModal={500}
      descriptionDelete={
        <>
          <BaseCol>
            <span>
              {t(R.strings.job_title_level_content_are_you_want_delete)}{' '}
              <S.TextJobTitleLevel>{props?.name ?? ''}</S.TextJobTitleLevel>
            </span>
          </BaseCol>
          <BaseCol>
            {t(
              R.strings
                .job_title_level_content_once_the_job_title_level_is_locked_it_cannot_be_recovered,
            )}
          </BaseCol>
        </>
      }
    />
  )
}
